export const dataKey = 'corrections' as const
